import React from 'react';
import { Section } from './ui/Section';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getContent } from '../utils/contentStore';
import { renderIcon } from '../utils/iconMap';
import { useLanguage } from '../utils/i18n';
export function PartnerSection() {
  const s = getContent().partnerSection;
  const benefits = getContent().partnerBenefits.slice(0, 4);
  const {
    loc
  } = useLanguage();
  return <Section dark className="relative overflow-hidden" data-id="element-349">
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-350">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-white rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" data-id="element-351" />
      </div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-352">
        <div data-id="element-353">
          <h2 className="text-gray-400 font-bold tracking-widest uppercase mb-3 text-sm" data-id="element-354">
            {loc(s.label)}
          </h2>
          <h3 className="font-heading text-4xl md:text-5xl font-bold text-white uppercase mb-6 leading-tight" data-id="element-355">
            {loc(s.title)}{' '}
            <span className="text-red-500" data-id="element-356">{loc(s.titleAccent)}</span>
          </h3>
          <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-357">
            {loc(s.description)}
          </p>
          <Link to="/partner" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-medium uppercase tracking-wide px-8 py-4 text-base rounded-sm transition-all duration-200 shadow-md hover:shadow-lg" data-id="element-358">
            {loc(s.ctaText)}
            <ArrowRight className="h-5 w-5" data-id="element-359" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-360">
          {benefits.map(b => <div key={b.id} className="bg-white/5 backdrop-blur-sm p-6 rounded-sm border border-white/10 hover:border-white/30 transition-colors" data-id="element-361">
              <div className="bg-white/10 w-12 h-12 flex items-center justify-center rounded-sm mb-4 text-white" data-id="element-362">
                {renderIcon(b.icon, 'h-6 w-6')}
              </div>
              <h4 className="font-bold text-lg mb-2 text-white" data-id="element-363">
                {loc(b.title)}
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-364">{loc(b.description)}</p>
            </div>)}
        </div>
      </div>
    </Section>;
}